export default Object.freeze({
  API_URL: 'http://localhost:3001',
})
